import { Input, message } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import { graphicStore } from "@/commons/store/graphic-store";
import { LayerType } from "@/commons/enums/layer-type";
import { HVAC_SUB_CONTROL } from "@/passets/hvac-engine/enums/hvac-sub-control";
import { HVAC_SIGNAL } from "@/passets/hvac-engine/enums/hvac-signal";
import { HVAC_CTRL_TYPE } from "@/passets/hvac-engine/enums/hvac-control-type";
import { ENTITY_TYPE, Point, Pyramid, PyramidT } from "pytha";
import { Vector3 } from "three";
import { getSpecialPrimitiveLayerUuid } from "@/commons/utils/layer-utils";
import { HvacExhaustOpeningT } from "@/passets/hvac-engine/models/HvacExhaustOpeningT";


const enum OutLetType {
    RECTANGLE,
    ROUND
}

function generateExhaustOpeningBlock(name: string, width1: number, width2: number, height: number, outLetType: OutLetType, layerUuid: string): HvacExhaustOpeningT {
    // 棱台
    let cutNum = outLetType == OutLetType.RECTANGLE ? 4 : 30;
    let pyramid = new Pyramid(new Point(0, 0, -height), width2 / 2, height, cutNum, width1 / 2, new Vector3(0, 0, 1), new Vector3(1, 0, 0))
    let pyramidT = new PyramidT(pyramid);
    let entities = [pyramidT];
    let hvacExhaustOpeningT: HvacExhaustOpeningT = new HvacExhaustOpeningT(new Point(0, 0, 0), entities, name, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
    hvacExhaustOpeningT.layerUuid = layerUuid;
    return hvacExhaustOpeningT;
}

export function HavcDeviceExhaustOpeningRectanglePanel() {
    const { projectId, modelUuid } = useParams();
    const MODEL_NAME = "排风口-矩形";
    const [width1, setWidth1] = useState<number>(0);        // 矩形排风口宽度1
    const [width2, setWidth2] = useState<number>(0);        // 矩形排风口宽度2
    const [height, setHeight] = useState<number>(0);        // 矩形排风口高度
    const [offset, setOffset] = useState<number>(0);        // 相对标高的偏移

    const assemble = () => {
        if (!width1) {
            message.warning("请输入宽度1");
            return;
        }

        if (!width2) {
            message.warning("请输入宽度2");
            return;
        }

        if (!height) {
            message.warning("请输入高度");
            return;
        }

        getSpecialPrimitiveLayerUuid(projectId, modelUuid, LayerType.EXHAUSTOPENING).then((layerUuid: string) => {
            // 激活布置构件的二级控制器
            const currentCmdControl = graphicStore.extraContext.getCurrentViewEditor().cmdControl;
            if (currentCmdControl) {
                graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
            }

            let data = {
                name: MODEL_NAME,
                comType: LayerType.EXHAUSTOPENING,
            }

            let hvacExhaustOpeningT: HvacExhaustOpeningT = generateExhaustOpeningBlock(MODEL_NAME, width1, width2, height, OutLetType.RECTANGLE, layerUuid);
            currentCmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACDEVICECONTROL.name);
            graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacDeviceControl).dispatch(data, ENTITY_TYPE.HAVC, hvacExhaustOpeningT, offset);
        })

    }

    return (
        <>
            <div className="row compact">
                <div className="label">宽度1(mm):</div>
                <Input
                    size='small'
                    value={width1}
                    className="input-box"
                    placeholder='宽度1(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setWidth1(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">宽度2(mm):</div>
                <Input
                    size='small'
                    value={width2}
                    className="input-box"
                    placeholder='宽度2(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setWidth2(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">高度(mm):</div>
                <Input
                    size='small'
                    value={height}
                    className="input-box"
                    placeholder='高度(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setHeight(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">相对标高偏移(mm):</div>
                <Input
                    size='small'
                    value={offset}
                    className="input-box"
                    placeholder='相对标高偏移(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setOffset(parseFloat(value));
                    }}
                />
            </div>
            <div className='bottom-footer'>
                <div className="ope-btn">
                    <div className="insert-button" onClick={assemble}>
                        <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                        <div className="text">布置</div>
                    </div>
                </div>
            </div>
        </>
    )
}


export function HavcDeviceExhaustOpeningRoundPanel() {
    const { projectId, modelUuid } = useParams();
    const MODEL_NAME = "排风口-圆形";
    const [diameter1, setDiameter1] = useState<number>(0);          // 圆形排风口直径1
    const [diameter2, setDiameter2] = useState<number>(0);          // 圆形排风口直径2
    const [height, setHeight] = useState<number>(0);                // 圆形排风口高度
    const [offset, setOffset] = useState<number>(0);                // 相对标高的偏移

    const assemble = () => {
        if (!diameter1) {
            message.warning("请输入直径1");
            return;
        }

        if (!diameter2) {
            message.warning("请输入直径2");
            return;
        }

        if (!height) {
            message.warning("请输入高度");
            return;
        }

        getSpecialPrimitiveLayerUuid(projectId, modelUuid, LayerType.EXHAUSTOPENING).then((layerUuid: string) => {
            // 激活布置构件的二级控制器
            const currentCmdControl = graphicStore.extraContext.getCurrentViewEditor().cmdControl
            if (!currentCmdControl.currentControl || currentCmdControl.currentControl.id !== HVAC_CTRL_TYPE.ADD_HVAC_DEVICE_CONTROL) {
                currentCmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACDEVICECONTROL.name);
            }

            let data = {
                name: MODEL_NAME,
                comType: LayerType.EXHAUSTOPENING,
            }

            let hvacExhaustOpeningT: HvacExhaustOpeningT = generateExhaustOpeningBlock(MODEL_NAME, diameter1, diameter2, height, OutLetType.ROUND, layerUuid);
            graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacDeviceControl).dispatch(data, ENTITY_TYPE.HAVC, hvacExhaustOpeningT, offset);
        });

    }

    return (
        <>
            <div className="row compact">
                <div className="label">直径1(mm):</div>
                <Input
                    size='small'
                    value={diameter1}
                    className="input-box"
                    placeholder='直径1(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setDiameter1(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">直径2(mm):</div>
                <Input
                    size='small'
                    value={diameter2}
                    className="input-box"
                    placeholder='直径2(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setDiameter2(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">高度(mm):</div>
                <Input
                    size='small'
                    value={height}
                    className="input-box"
                    placeholder='高度(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setHeight(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">相对标高偏移(mm):</div>
                <Input
                    size='small'
                    value={offset}
                    className="input-box"
                    placeholder='相对标高偏移(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setOffset(parseFloat(value));
                    }}
                />
            </div>
            <div className='bottom-footer'>
                <div className="ope-btn">
                    <div className="insert-button" onClick={assemble}>
                        <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                        <div className="text">布置</div>
                    </div>
                </div>
            </div>
        </>
    )
}